import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PendingRequestsState {
    withdrawals: number;
    bingx: number;
    topups: number;
    lastUpdated: string | null;
}

const initialState: PendingRequestsState = {
    withdrawals: 0,
    bingx: 0,
    topups: 0,
    lastUpdated: null,
};

interface UpdateCountsPayload {
    withdrawals?: number;
    bingx?: number;
    topups?: number;
}

const pendingRequestsSlice = createSlice({
    name: "pendingRequests",
    initialState,
    reducers: {
        updateCounts: (state, action: PayloadAction<UpdateCountsPayload>) => {
            const { withdrawals, bingx, topups } = action.payload;

            if (typeof withdrawals === "number") {
                state.withdrawals = withdrawals;
            }
            if (typeof bingx === "number") {
                state.bingx = bingx;
            }
            if (typeof topups === "number") {
                state.topups = topups;
            }

            state.lastUpdated = new Date().toISOString();
        },
        resetCounts: () => initialState,
    },
});

export const { updateCounts, resetCounts } = pendingRequestsSlice.actions;
export default pendingRequestsSlice.reducer;

